import { callApi } from './ApiClient';

const getSenders = (dispatch) => {
  return callApi('GET', '/senders', null, dispatch);
}

const postSender = (data, dispatch) => {
  return callApi('POST', '/senders', data, dispatch);
}

const putSender = (data, dispatch) => {
  return callApi('PUT', `/senders/${data.id}`, data, dispatch);
}

const deleteSender = (id, dispatch) => {
  return callApi('DELETE', `/senders/${id}`, null, dispatch);
}

export const SendersApi = {
  getSenders,
  postSender,
  putSender,
  deleteSender,
};



// WEBPACK FOOTER //
// ./src/redux/api/SendersApi.js